import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, Ref } from 'vue-property-decorator';
import { CLASSES_STORE } from '@/classes/store/classes.store';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { APP_EVENT_BUS } from '@/core/enums/app.enum';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-student-list-class',
  components: {
  }
})
export default class EdStudentListClassComponent extends Vue {


  /* Props */
  @Prop() readonly orgId: number;
  @Prop() readonly userItem: any;
  @Prop() readonly origin: string;

  @Ref('dataTable') readonly dataTable: any;

  /* Data */
  public loading: boolean = true;
  public classes: any = []
  public pagination: object = { current: 1, total: 0 }
  public loadingAdd: boolean = false;
  public addObj: Object = {};
  public addingStudent = false;
  public search = EdInputModel('search',  '');

  /* Computed */
  get headers() {
    return [
      { text: this.$t('tools.student.class.headers.name'), value: 'name', show: true, sortable: true, width: '80%' },
      { text: this.$t('tools.student.class.headers.action'), value: 'action', show: true, sortable: false, width: '20%' }
    ].filter(el => el.show)
  }

  get classesList(): any[] {
    return this.classes;
  }

  /* Methods */
  searchClassByUser() {
    this.loading = true;
    //-- Load classes by Org
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.GET_CLASS_BY_ORG_A}`, {
      orgId: this.orgId,
      userId: this.userItem.id,
      page:  this.pagination['current']-1,
      pageSize: 10,
      search: this.search.value
    }).then((res) => {
      this.classes = res.content;
      this.loading = false;
      this.pagination['total'] = res.totalPages;
    }).catch(() => {
      // Handle error
      this.classes = [];
      this.loading = false;
    })
  }

  removeStudent(classItem: Object) {
    this.$EdModal.createConfirmationModal(
        {
          body: this.$t('classes.students.confirmRemove', {studentName: this.userItem['firstName'], className: classItem['name']}),
          action: async () => {
            this.removeStudentConfirm(this.userItem.id, classItem['id']);
          }
        }
    );
  }

  removeStudentConfirm (userId: number, classId: number) {
    this.loading = true;
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.REMOVE_STUDENT_FROM_CLASS_A}`,
        {
          classId: classId,
          studentId: userId
        }
    ).then(() => {
      this.searchClassByUser();
      this.$EdToast.create({
        msg:  `${this.$t('classes.success.studentRemoved')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
    }).catch(() => {
      this.$EdToast.create({
        msg:  `${this.$t('classes.errors.studentNoRemoved')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });

      this.loading = false;
    })
  }

  addStudent(classItem: Object) {
    this.addObj = classItem;
    this.loadingAdd = true;
    this.addingStudent = true;
    this.dataTable?.updateItem(classItem);
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.ADD_STUDENT_TO_CLASS_A}`,
        { classId: classItem['id'],  studentId: this.userItem.id }
    ).then(() => {
      this.loadingAdd = false;
      this.addingStudent = false;
      this.addObj = {};
      this.searchClassByUser();
      this.$EdToast.create({
        msg:  `${this.$t('classes.success.studentAdded')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
    }).catch(() => {
      this.loadingAdd = false;
      this.addingStudent = false;
      this.addObj = null;
      this.$EdToast.create({
        msg:  `${this.$t('classes.errors.studentNoAdded')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
    }).finally(() => {
      this.dataTable?.updateItem(classItem);
    });
  }

  isVisibleAddButton(item:Object){
    let ret : boolean;
    // @ts-ignore
    if (this.addObj.id !== undefined && this.addObj['id'] !== item['id'] && item['studentId'] == null){
        ret = true
    }else{
        ret = !this.addingStudent && item['studentId'] == null;
    }
    return ret;
  }

  public onPageUpdate(customEvent: CustomEvent): void {
    const detail: { page: number } = customEvent.detail;
    this.pagination['current'] = detail.page;
    this.searchClassByUser();
  }

  private _loadClassesInDataTable(): void {
    if (!this.dataTable || !this.dataTable.loadData) {
      return;
    }

    if (!this.classesList || this.classesList.length == 0) {
      this.dataTable.loadData({ items: [], headers: this.headers });
      return;
    }

    const slots = {
      'item.action': {
        template: document.querySelector('#item\\.action').innerHTML,
        templateParams: [{}],
        expressions: [
          {
            target: '.spinner', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.parent.loadingAdd && (params.parent.addObj?.id === params.item.id),
            applied: 'display: inline;', fallback: 'display: none;'
          },
          {
            target: '.actionButtons', attribute: 'style', booleanAttribute: false,
            expression: (params) => !params.parent.loadingAdd,
            applied: 'display: inline;', fallback: 'display: none;'
          },
          {
            target: '.addedStudent', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.item.studentId != null,
            applied: 'display: inline;', fallback: 'display: none;'
          },
          {
            target: '.removeStudent', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.item.studentId != null,
            applied: 'display: inline;', fallback: 'display: none;'
          },
          {
            target: '.addStudent', attribute: 'style', booleanAttribute: false,
            expression: (params) => params.parent.isVisibleAddButton(params.item),
            applied: 'display: inline;', fallback: 'display: none;'
          },
        ],
        events: [
          { target: '.removeStudent', handler: (params) => params.parent.removeStudent(params.item) },
          { target: '.addStudent', handler: (params) => params.parent.addStudent(params.item) },
        ],
      },
      parent: this,
    };

    this.dataTable.loadData({
      items: this.classesList,
      headers: this.headers,
      slots: slots,
    });
  }

  private _onLanguageChanged(lang: string): void {
    this.$nextTick(() => {
      this.dataTable?.setAttribute('lang', lang);
      this._loadClassesInDataTable();
    });
  }

  /* Watch */
  @Watch('userItem', { immediate: true, deep: true })
  onChangeUser() {
    this.classes = [];
    this.pagination['current'] = 1;
    this.searchClassByUser();
  }

  @Watch('search.value')
  searchStudents(value: string): void {
    if (!this.loading || value == null || value === '') {
      this.pagination['current'] = 1;
      this.searchClassByUser();
    }
  }

  @Watch('classesList')
  onChangeClassesList() {
    this._loadClassesInDataTable();
  }

  /* Hooks */
  mounted() {
    this.$edEventBus.$on(APP_EVENT_BUS.LANGUAGE_CHANGED, this._onLanguageChanged);
  }

  beforeDestroy() {
    this.$edEventBus.$off(APP_EVENT_BUS.LANGUAGE_CHANGED, this._onLanguageChanged);
  }
}
